module.exports = __webpack_public_path__ + "static/media/facebook.f4c2b29b.svg";